import React, { useState, useEffect } from "react";
import Select from "live/components/forms/ui/select";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { fetchApi } from "../../../api/fetchApi";
import { listUserGroupsApi } from "../../../api/userGroupApi";

const UserGroupBox = ({
  company,
  addGroup,
  removeGroup,
  itemUrl,
  perspective,
}) => {
  const [options, setOptions] = useState([]);

  let showSelect = true;

  useEffect(() => {
    listUserGroupsApi(company.id)
    .then((response) => {
        let myOptions = response.data.map((group) => {
          //All groups
          return { id: group.id, name: group.name };
        });

        const removeItemFromMyOptions = (id) => {
          myOptions = myOptions.filter((option) => {
            return option.id !== id;
          });
        };

        perspective.groups.map((group) => {
          removeItemFromMyOptions(group.id);
        });

        setOptions(myOptions);
    });
  
  }, [perspective.id]);

  useEffect(() => {}, [perspective.groups]);

  const getItem = (id) => {
    let index;
    const item = options.find((d, i) => {
      if (d["id"] === id) {
        index = i;
        return true;
      }
    });

    return item ? item : false;
  };

  const addItem = (id) => {
    const item = getItem(id);

    if (item) {
      addGroup(item);
      removeItemFromOptions(id);
    }
  };

  const removeItem = (itemToRemove) => {
    removeGroup(itemToRemove);
    setOptions([{ id: itemToRemove.id, name: itemToRemove.name }, ...options]);
  };

  const removeItemFromOptions = (id) => {
    setOptions(
      options.filter((option) => {
        return option.id !== id;
      })
    );
  };

  return (
    <div className="select-list">
      <Select
        label="Add user groups to this perspective:"
        // placeholder={placeholder}
        options={options.map((group) => {
          return { value: group.id, label: group.name };
        })}
        // creatable={creatable}
        onChange={(value, option) => addItem(value)}
        className="Select-small"
        clearable={false}
        searchable={true}
      />
      <div className="list-area">
        <ul>
          {perspective.groups.map((d) => (
            <li key={d["id"]}>
              {d["name"]}

              {showSelect ? (
                <span>
                  {itemUrl ? (
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="exclude">{"View tooltip"}</Tooltip>}
                    >
                      <a
                        href={`${itemUrl}/${d["name"]}`}
                        target="_blank"
                        className="fa fa-external-link"
                      />
                    </OverlayTrigger>
                  ) : (
                    ""
                  )}

                  {company["adminGroupId"] == d["id"]  ? (
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="exclude">
                          {
                            "This user group has access to all perspectives by definition"
                          }
                        </Tooltip>
                      }
                    >
                      <i className="fa fa-info-circle" />
                    </OverlayTrigger>
                  ) : (
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="exclude">{"Remove tooltip"}</Tooltip>
                      }
                    >
                      <button
                        className="remove-item warn"
                        onClick={() => removeItem(d)}
                      />
                    </OverlayTrigger>
                  )}
                </span>
              ) : null}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default UserGroupBox;
